import { localDate } from '@/platform/lib/utils';
import {
    Badge,
    Button,
    Segment,
    SegmentContent,
    SegmentHeader,
} from '@/platform/ui';
import { PlusIcon } from '@heroicons/react/24/outline';
import { usePage } from '@inertiajs/react';
import dayjs from 'dayjs';
import { useState } from 'react';
import NoRiskEntitlementCard from './components/NoRiskEntitlementCard';
import NoRiskEntitlementPanel from './components/NoRiskEntitlementPanel';
import EmployeeShowLayout from './layouts/EmployeeShowLayout';

const isActive = entitlement =>
    !dayjs(entitlement.start_date).isAfter(dayjs(), 'day') &&
    (!entitlement.end_date ||
        !dayjs(entitlement.end_date).isBefore(dayjs(), 'day'));

const NoRiskView = () => {
    const { auth, employee } = usePage().props;

    const [editing, setEditing] = useState(null);

    const entitlements = [...(employee?.no_risk_entitlements ?? [])].sort(
        (a, b) => dayjs(b.start_date).diff(dayjs(a.start_date))
    );
    const active = entitlements.find(isActive);

    return (
        <>
            <Segment>
                <SegmentHeader
                    header={
                        <span className='inline-flex items-center gap-2'>
                            No-riskpolis
                            {active ? (
                                <Badge color='green'>Actief</Badge>
                            ) : (
                                <Badge color='gray'>Niet actief</Badge>
                            )}
                        </span>
                    }
                    subheader={
                        active
                            ? `${active.reason_label} · sinds ${localDate(active.start_date)}${active.end_date ? ` tot ${localDate(active.end_date)}` : ', doorlopend'}`
                            : 'Deze werknemer valt op dit moment niet onder de no-riskpolis.'
                    }
                >
                    {auth?.permissions?.includes('create no-risk') && (
                        <Button
                            type='button'
                            variant='primary'
                            onClick={() => setEditing(false)}
                        >
                            <PlusIcon className='size-4' />
                            Toevoegen
                        </Button>
                    )}
                </SegmentHeader>
                {entitlements.length === 0 && (
                    <SegmentContent>
                        <p className='text-sm text-gray-500'>
                            Deze werknemer heeft nog geen no-riskperiodes. Voeg
                            er een toe als de werknemer onder de no-riskpolis
                            valt.
                        </p>
                    </SegmentContent>
                )}
            </Segment>

            {entitlements.map(entitlement => (
                <NoRiskEntitlementCard
                    entitlement={entitlement}
                    onEdit={setEditing}
                    key={entitlement.id}
                />
            ))}

            {editing !== null && (
                <NoRiskEntitlementPanel
                    entitlement={editing || null}
                    onClose={() => setEditing(null)}
                />
            )}
        </>
    );
};

NoRiskView.layout = page => <EmployeeShowLayout>{page}</EmployeeShowLayout>;

export default NoRiskView;
